import { z } from 'zod';

export const PermitsChargesScalarFieldEnumSchema = z.enum(['id','permit_id','fee_schedule_id','amount','details','paid','created_at','updated_at','pending','transaction_id','payment_method','payment_description','active','fee_id','permits_extension_id','fee_item_id','subtotal','rowTimestamp']);

export default PermitsChargesScalarFieldEnumSchema;
